import { render, staticRenderFns } from "./TAPRecords.vue?vue&type=template&id=6a79c178"
import script from "./TAPRecords.vue?vue&type=script&lang=ts"
export * from "./TAPRecords.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports